/**
 * Sheet-based special avatars (Turtle Man, DJ Shark, Party Gorilla, Disco Yeti).
 * All sheets: 384x256 — 6 cols x 4 rows of 64px. Rows: 0=up, 1=left, 2=down, 3=right.
 */

export const SPECIAL_SHEETS = {
  special_turtle_man: '/sprites/turtle_sheet.png?v=6',
  special_dj_shark: '/sprites/special_dj_shark.png?v=3',
  special_party_gorilla: '/sprites/special_party_gorilla.png?v=3',
  special_disco_yeti: '/sprites/special_disco_yeti.png?v=3',
};

const ROWS = { up: 0, left: 1, down: 2, right: 3 };
const _imgs = {};
const _ready = {};

export function isSheetSpecial(id) {
  return Boolean(id && SPECIAL_SHEETS[id]);
}

function ensureImg(id) {
  if (_imgs[id]) return _imgs[id];
  if (typeof Image === 'undefined') return null;
  const img = new Image();
  img.onload = () => { _ready[id] = true; };
  img.onerror = () => { _ready[id] = false; };
  img.src = SPECIAL_SHEETS[id];
  _imgs[id] = img;
  return img;
}

// Pre-warm all sheets so equipping never flickers the fallback
if (typeof Image !== 'undefined') {
  Object.keys(SPECIAL_SHEETS).forEach(ensureImg);
}

export function drawSpecialSprite(ctx, specialId, x, y, scale = 1, direction = 'down', isWalking = false, walkPhase = 0) {
  const img = ensureImg(specialId);
  if (img && _ready[specialId]) {
    const size = 96 * scale;
    const row = ROWS[direction] ?? 2;
    // 5-frame walk cycle (cols 1-5, col 0 is the idle pose), cadence matched to regular sprites
    const col = isWalking ? 1 + (Math.floor(walkPhase * 0.625) % 5) : 0;
    const bob = isWalking ? 0 : Math.sin(Date.now() * 0.004) * 1.5 * scale;
    ctx.save();
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(img, col * 64, row * 64, 64, 64, x - size / 2, y - size / 2 + bob, size, size);
    ctx.restore();
    return;
  }
  // Fallback silhouette while loading
  ctx.save();
  ctx.fillStyle = specialId === 'special_turtle_man' ? '#52B788' : 'rgba(148,163,184,0.7)';
  ctx.beginPath();
  ctx.ellipse(x, y, 30 * scale, 22 * scale, 0, 0, Math.PI * 2);
  ctx.fill();
  ctx.restore();
}
